import {
  SET_PAGE,
  SET_FILTERS,
  SET_TAB,
  SET_DIRECTION,
  UPDATE_DATA,
  SET_LOADING_SHIPMENTS,
  SET_BROKER_JOBS,
  CURRENT_JOB_STATE,
  SET_TOTAL_NUMBER_OF_JOBS,
  GET_DOCUMENT_TYPES,
  ADD_NEW_TANSIT_CARD
} from "./index";
import store from "../store";
import { getBrokerShipments, getDocumentTypes } from "../apiCalls/jobInfo";
import { searchDirections, textFilters } from "../util/constants";
import stringConstants from "../util/stringResources.json";
import get from "lodash/get";
import { logout } from '../util'
import {getQueryVariable} from '../apiCalls/jobInfo'
// import { searchBrokerShipmentsWS, socketInstance } from '../socket'

export const updatePage = (page) => {
  return (dispatch, getState) => {
    dispatch(setLoadingShipments(true));
    dispatch(setPage(page));
    return dispatch(getBrokerShipmentList());
  };
};

export const updateFilters = (filters, searchAt, isLvs, extraParams) => { 
  return (dispatch, getState) => {
    dispatch(setLoadingShipments(true));
    dispatch(setFilters(filters, searchAt));
    return dispatch(getBrokerShipmentList(false, false, isLvs, extraParams));
  };  
};

export const searchByID = (shipmentId) => {
  return (dispatch, getState) => {
    dispatch(setLoadingShipments(true));
    dispatch(
      setFilters([
        {
          key: ['SEARCH_FILTERS_SHIPMENT_ID'],//referenced in textFilters
          value: shipmentId,
        },
      ], "all") 
    );
    return dispatch(getBrokerShipmentList());
  };
};

export const searchTransitShipmentByID = (shipmentId) => {
  store.dispatch(setLoadingShipments(true));
  store.dispatch(
    setFilters([
      {
        key: ['SEARCH_FILTERS_SHIPMENT_ID'],//referenced in textFilters
        value: shipmentId,
      },
    ], "all") 
  );
  return store.dispatch(getBrokerShipmentList());
}

export const updateTab = (tab) => {
  return (dispatch, getState) => {
    dispatch(setLoadingShipments(true));
    dispatch(setTab(tab));
    if (tab === stringConstants.searchFilters.SEARCH_TAB_MOST_RECENT) {
      dispatch(setDirection(searchDirections.descending));
    }
    if (tab === stringConstants.searchFilters.SEARCH_TAB_ARRIVAL_TIME) {
      dispatch(setDirection(searchDirections.ascending));
    }
    return dispatch(getBrokerShipmentList());
  };
};

// Changes the search direction to the opposite unless an explicit direction is provided
export const updateSearchDirection = (direction) => {
  return (dispatch, getState) => {
    dispatch(setLoadingShipments(true));
    if (direction) {
      dispatch(setDirection(direction));
    } else {
      if (getState().searchContext.direction === searchDirections.ascending) {
        dispatch(setDirection(searchDirections.descending));
      } else {
        dispatch(setDirection(searchDirections.ascending));
      }
    }
    return dispatch(getBrokerShipmentList());
  };
};

export const getBrokerShipmentList = (callback_1, callback_2, _isLvs, extraParams={}) => {
  const _isPartialTextSearchEnabled = extraParams?.isPartialTextSearchEnabled || false;
  const isEngine = 'kxEngineBrokerToken' == window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN;
  let state = store.getState();
  let { page, filters, searchTab, direction } = state.searchContext;
  return (dispatch, getState) => {
    let isLvsShipment = _isLvs || (window.shipmentMode === 'LVS_SHIPMENTS');
    
    // Use WebSocket if connected, otherwise fall back to HTTP
    // const useWS = socketInstance.isConnected();
    // const apiCall = useWS
    //   ? searchBrokerShipmentsWS(filters, page, searchTab, direction, isLvsShipment)
    //   : getBrokerShipments(filters, page, searchTab, direction, isLvsShipment);
    const apiCall = getBrokerShipments(filters, page, searchTab, direction, isLvsShipment, _isPartialTextSearchEnabled);

    return apiCall
      .then((res) => {
        for (let onejob of res?.data?.eventMessage?.brokerJobs?.currentBrokerJobs || []) {
          // isShipment broker-search jobs sometimes omit countryCode.
          // Prefer URL country, then US default so EntryReleaseForm can pick CBP/CBSA/EU.
          onejob.countryCode =
            onejob.countryCode ||
            onejob.countryOfBusiness ||
            getQueryVariable("countryHttpParameter") ||
            getQueryVariable("transactionCountry") ||
            "US";
          if (!onejob.formType || onejob.formType === "FORM_NONE") {
            if (onejob.countryCode === "US") onejob.formType = "CBP";
            else if (onejob.countryCode === "CA") onejob.formType = onejob.formType || "CBSA";
          }
        }
//         setTimeout(()=>{
//           let isAlreadySelected = (document.querySelector(".broker-card.active.selected")?.id+"").includes(document.getElementById('shipmentIdInHeaderx')?.value)
//           if(!isAlreadySelected){
//             document.querySelector(".broker-card.active.selected") && document.querySelector(".broker-card.active.selected").click();
//           }
//         },2200);

        //SEARCH_SHIPMENTS_BROKER

        let brokerJobs = get(
          res,
          "data.eventMessage.brokerJobs.currentBrokerJobs",
          null
        );
        if(window.shipmentMode === 'TRANSIT_SHIPMENTS'){
          brokerJobs = get(
            res,
            "data.eventMessage.shipmentInfo",
            null
          );
        }
        
        (brokerJobs||[]).map(x=>x.timeRemaining=null);
        
        let totalJobs = get(res, "data.eventMessage.totalShipmentCount", 0) || get(res, "data.eventMessage.totalJobCount", 0);
        let msg = get(res, "data.eventMessage.header.msg", null);
        if ((msg === "No jobs for broker " || msg === "No jobs for Transit " || (!brokerJobs && !totalJobs))) {
          dispatch({
            type: "SET_NO_JOBS_FOUND",
            value: true,
          });
          dispatch(setTotalNumberOfJobs(totalJobs));
        } else {
          
          dispatch(setBrokerJobs(brokerJobs));
          dispatch(setTotalNumberOfJobs(totalJobs));
          if (callback_1 && callback_2) {
            console.log("getBrokerShipmentList before callback_1");
            callback_1(res);
            callback_2(res);
          }
        }

        if (isLvsShipment && extraParams?.parentShipmentId && extraParams?.shipmentId) {

          const handleChildShipmentCard = (params) => {
            const shipmentCardChild = document.querySelector(`#card-${params.shipmentId}`)
            // shipmentCardChild && shipmentCardChild.click()
            
            if (shipmentCardChild) {
              shipmentCardChild.click()
            }
          }

          const handleOpenChildShipment = (params) => {

            const shipmentCardParentIcon = document.querySelector(`#child-of-parent-${params.parentShipmentId}-icon`)
            // shipmentCardParentIcon && shipmentCardParentIcon.click()
            if (shipmentCardParentIcon) {
              shipmentCardParentIcon.click()
            }

            setTimeout(() => handleChildShipmentCard(params), 500)
          }

          const handleShipmentCard = (params) => {

            const shipmentCardItem = document.querySelector(`#card-item-${params.parentShipmentId}`)
            // shipmentCardItem && shipmentCardItem.click()
            
            if (shipmentCardItem) {
              shipmentCardItem.click()
            }

            setTimeout(() => handleOpenChildShipment(params), 500)
          }

          setTimeout(() => handleShipmentCard(extraParams), 500)

        }

      })
      .catch((err) => {
        console.error("Could Not Get Broker Jobs", err);
        dispatch(setBrokerJobs(null));
        dispatch(setLoadingShipments(false));
      });
  };
};

export const setDocumentTypes = () => {
  let launchFromIframe = getQueryVariable("onlyOneShipment");
  return (dispatch, getState) => {
    return getDocumentTypes()
      .then((res) => {
        dispatch(_getDocumentTypes(get(res, "data.eventMessage.docTypes", [])));
      })
      .catch((err) => {
        let xmessage = get(err,"response.data","");
        let xcode = get(err,"response.status","");
        if((launchFromIframe && xmessage.includes && xmessage.includes("security check")) || xcode == 400){
          if(!window.confirm("It looks like you were logged out. Redirecting to login page..."))return;
          logout();
        }
        console.error(err);
      });
  };
};

export const setPage = (page) => {
  return {
    type: SET_PAGE,
    page,
  };
};

export const setFilters = (filters, searchAt) => {
  return {
    type: SET_FILTERS,
    filters,
    searchAt
  };
};

export const setTab = (tab) => {
  return {
    type: SET_TAB,
    tab,
  };
};

export const setDirection = (direction) => {
  return {
    type: SET_DIRECTION,
    direction,
  };
};

export const updateData = (key, value) => {
  return {
    type: UPDATE_DATA,
    key,
    value,
  };
};

export const setLoadingShipments = (value) => {
  return {
    type: SET_LOADING_SHIPMENTS,
    value,
  };
};

export const setBrokerJobs = (value) => {
  return {
    type: SET_BROKER_JOBS,
    value,
  };
};
export const setCurrentBrokerJob = (currentShipmentId, currentJobData) => {
  return {
    type: CURRENT_JOB_STATE,
    currentShipmentId,
    currentJobData
  }
};

export const setTotalNumberOfJobs = (value) => {
  return {
    type: SET_TOTAL_NUMBER_OF_JOBS,
    value,
  };
};

export const _getDocumentTypes = (documentTypes) => {
  return {
    type: GET_DOCUMENT_TYPES,
    documentTypes,
  };
};

export const addNewTransitCard = (jobData) => {
 
  return (dispatch, getState) => { 
    store.dispatch({
      type: ADD_NEW_TANSIT_CARD,
      jobData
    }) 
    
  }
}
